module.exports = __webpack_public_path__ + "img/default-article-bg.5f032bb8.jpg";